import { TextArea } from "devextreme-react";
import { Form, GroupItem, SimpleItem } from "devextreme-react/form";
import { forwardRef } from "react";
import { useSelector } from "react-redux";
import { getLocalized } from "../../redux/localization";
import { createAdminSSS } from "./type";

const adminCreateSSSForm = forwardRef<any, { data: createAdminSSS }>((
    { data }, ref
) => {
    const localize = useSelector(getLocalized);
    return <Form
        formData={data}
        ref={ref}
    >
        <GroupItem>
            <SimpleItem
                dataField={"Question"}
                editorType={"dxTextBox"}
                label={{
                    text: localize.getString("question"),
                }}

            >
            </SimpleItem>
            <SimpleItem
                dataField={"Answer"}
                //editorType={"dxTextArea"}
                label={{
                    text: localize.getString("answer"),
                }}
                render={(e:any) => (
                    <TextArea
                        height={"100px"}
                        onValueChanged={(item:any) => {
                            data.Answer = item.value
                        }}
                    ></TextArea>
                )}
            >
            </SimpleItem>
        </GroupItem>
    </Form>
})

export default adminCreateSSSForm